import { IProject, IProjectSlot, ProjectToSlot } from 'screens/Projects/projects.types'
import Button from 'shared/Buttons/Button/Button'
import Card from 'shared/Cards/Card'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import projectsApi from 'screens/Projects/projects.api'
import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'
import EditButton from 'shared/Buttons/EditButton'
import { useState } from 'react'
import ProjectSlots from '../../ProjectSlots'
import eventBus from 'services/eventBus'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'
import ProjectSlotSettingsModal from '../../ProjectSlotSettingsModal'
interface IProps {
  project: IProject
  onJoined: (project: IProject) => void
  onLeft: (project: IProject) => void
  onUpdated: (project: Partial<IProject>) => void
}

const ProjectTeamsCard = (props: IProps) => {
  const isAdmin = useRecoilValue(authAtom).user.isAdmin

  const [selectedSlotId, setSelectedSlotId] = useState<IProjectSlot['id'] | undefined>()
  const [slotModalOpen, setSlotModalOpen] = useState(false)
  const [editing, setEditing] = useState(false)
  const { wait, loading } = useHttpLoader()

  const userId = useRecoilValue(authAtom).user.id
  const selfTeams = useRecoilValue(selfTeamsAtom).items
  const activeTeam = selfTeams[0]

  const selfTeamSlot = props.project.slots?.find((slot) => slot.claimedBy?.id === activeTeam?.id)
  const isTeamOwner = activeTeam?.ownerId === userId

  const joinProject = (slotId: string) => {
    wait(projectsApi.joinProject(props.project.id, slotId), (resp) => {
      if (resp.status === 'success') {
        eventBus.pub('ntf.message', { message: 'Команда записана на проект', type: 'info' })
        props.onJoined(resp.body.project)
      }
    })
  }

  const leaveProject = (slotId: string) => {
    wait(projectsApi.leaveProject(props.project.id, slotId), (resp) => {
      if (resp.status === 'success') {
        const updatedProject = {
          ...props.project,
          slots: props.project.slots.map((s) => (s.id === slotId ? resp.body : s)),
        }
        props.onLeft(updatedProject)
      }
    })
  }

  const handleClickSlot = (slotId: IProjectSlot['id']) => {
    if (isAdmin && editing) {
      setSelectedSlotId(slotId)
      setSlotModalOpen(true)
      return
    }
    joinProject(slotId)
  }

  const handleChangeSlot = (slot: ProjectToSlot) => {
    const slots = props.project.slots?.filter((s) => s.id !== slot.id)

    const updatedProject = {
      ...props.project,
      slots: [...slots, slot],
    }
    props.onUpdated(updatedProject)
  }

  const handleCreateSlot = (slot: ProjectToSlot) => {
    handleChangeSlot(slot)
    setSelectedSlotId(slot.id)
  }

  const handleDeleteSlot = () => {
    props.onUpdated({
      ...props.project,
      slots: props.project.slots?.filter((s) => s.id !== selectedSlotId),
    })
    setSlotModalOpen(false)
    setSelectedSlotId(null)
  }
  const selectedSlot = props.project.slots?.find((s) => s.id === selectedSlotId)

  const slotsSortedByClaimedFirst = [...(props.project.slots || [])].sort((a, b) => {
    const aClaimed = !!a.claimedBy
    const bClaimed = !!b.claimedBy
    if (aClaimed === bClaimed) return 0
    return aClaimed ? -1 : 1
  })
  const projectWithSortedSlots = { ...props.project, slots: slotsSortedByClaimedFirst }

  const handleLeave = (slotId: IProjectSlot['id']) => {
    isTeamOwner && slotId === selfTeamSlot.id && leaveProject(slotId)
  }

  const handleCloseModal = () => {
    setSlotModalOpen(false)
    setSelectedSlotId(null)
  }

  return (
    <Card type='normal' style={{ height: '100%', width: '100%' }}>
      {slotModalOpen && (
        <ProjectSlotSettingsModal
          onClose={handleCloseModal}
          slot={selectedSlot}
          projectId={props.project.id}
          onChange={handleChangeSlot}
          onCreate={handleCreateSlot}
          onDelete={handleDeleteSlot}
        />
      )}
      <div className='flex-lines'>
        <div className='flex-space-between'>
          <h2 className='text--caption-l'>Команды</h2>
          {isAdmin && !editing && <EditButton onClick={() => setEditing(true)} />}
        </div>
        <div className='flex-lines'>
          <ProjectSlots
            project={projectWithSortedSlots}
            onClickSlot={handleClickSlot}
            loading={loading}
            editing={editing}
            onClickSlotDelete={handleLeave}
          />
        </div>
        {editing && (
          <div className='form-footer'>
            <div className='inline-flex-gap'>
              <Button
                theme='primary'
                style={{ width: 'fit-content' }}
                onClick={() => {
                  setSlotModalOpen(true)
                }}
              >
                Добавить слот
              </Button>
              <Button
                theme='grey-outline'
                style={{ width: 'fit-content' }}
                onClick={() => {
                  setEditing(false)
                }}
              >
                Отмена
              </Button>
            </div>
          </div>
        )}
      </div>
    </Card>
  )
}

export default ProjectTeamsCard
